module.exports = "/cyber/_next/static/images/replenish-steam-bg-mobile-9329778e47cfa9d2b9aa4a4dfeba187b.jpg";